

import { IngredientsList } from "./style";

const Ingredients = ({ content }) => {
  //console.log({content});
  const ingredientsTitle = content?.title ?? "Ingredientes";

  return <IngredientsList>
    <p>{ingredientsTitle}</p>
    <ul>
      {content?.value?.map((element, index) => <li key={`ingredients${index}`}>- {element}</li>)}
    </ul>
  </IngredientsList>
};

export default Ingredients;